import { createRef, Component } from 'react';
import propTypes from 'prop-types';

export class EditNameField extends Component {
  constructor(props) {
    super(props);
    this.inputRef = createRef();
  }

  componentDidMount() {
    this.inputRef.current.focus();
  }

  onFinishEdit = () => {
    const nextValue = this.inputRef.current.value;

    this.props.item.changeValue(nextValue);
    this.props.item.changeEditMode(false);
  };

  onKeyPressed = (event) => {
    if (event.key === 'Enter') {
      this.onFinishEdit();
    }
  };

  render() {
    const { item } = this.props;

    return (
      <input
        className="cart-group__title cart-group__title--editable"
        ref={this.inputRef}
        type="text"
        defaultValue={item.name}
        onBlur={this.onFinishEdit}
        onKeyPress={this.onKeyPressed}
      />
    );
  }
}

EditNameField.propTypes = {
  item: propTypes.shape({
    name: propTypes.string,
    changeEditMode: propTypes.func,
    changeValue: propTypes.func
  }).isRequired
};
